"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../react_utils";
var bem = ReactUtils.makeBem("carrier-labels");
const removeDuplicates = (list) => [...new Set(list)];
function labelName(label2) {
  var ret = label2.name || label2;
  if (ret && _.isString(ret)) {
    return ret;
  } else {
    throw "Invalid label. Label needs to be a string or an object with a non-null name member. Label was" + label2;
  }
}
function label(item) {
  var name = labelName(item);
  return /* @__PURE__ */ React.createElement("div", { className: bem("__label"), key: name }, name);
}
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("", this.props.className) }, removeDuplicates(this.props.labels).map(label), this.editLink());
  },
  editLink: function() {
    if (this.props.onEdit) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__buttons") }, /* @__PURE__ */ React.createElement("a", { onClick: this.props.onEdit }, "Edit ..."));
    }
  }
});
